module.exports = __webpack_public_path__ + "img/4.ed76e864.jpg";